import React,{ useState, useEffect } from 'react'
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import './otp.scss'
import {  verifyJobOtp,markJobComplete } from "../../services/auth.service"
import { toast } from "react-toastify";
import { useDispatch } from 'react-redux';
import { setLoader } from '../../slice/commonSlice';
import { toast_error ,toast_success} from '../../config/Constant';
import OtpInput from 'react-otp-input';

const OTP = (props) => {
    console.log("props", props)
    const dispatch = useDispatch();
    const [status,setStatus] = useState(false)
    // const [otp, setOtp] = useState(null);
    const handleSubmit = async (e) => {
        // e.preventDefault();
        await  props.handleMarkComplete(props.jobId,props.job.userId._id);
         await  props.setOtpModal(false);
        // let payload = {
        //   jobId:props.jobId,
        //   userId:props.job.userId._id,
        //   jobStatus : "CO"
          
        // }
        // await dispatch(setLoader(true));
        // try {
        //   const response = await markJobComplete(payload);
        //   await dispatch(setLoader(false));
        //   toast.success(response?.data?.paymentMessage, toast_success)
        //   console.log("response",response)
        //   if(response?.data?.status){
        //     // props.handleMarkComplete(props.jobId);
        //     props.setOtpModal(false);
        //   }else{
        //     // setOtp(null)
        //     toast.error(response?.data?.message, toast_error)
        //   }
          
        // } catch (error) {
        //   toast.error(error?.data?.message, toast_error)
        //   await dispatch(setLoader(false));
        //   console.error("Error fetching profile data:", error);
        // }
    };

    // const handleJobDispute = () => {
    //     props.setOtpModal(false)
    //     props.handleDispute(true, props.job);
    // }
    return (
        <>
            <Modal
                size="sm"
                show={props.otpModal}
                onHide={() => props.setOtpModal(false)}
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                  <Modal.Header closeButton></Modal.Header>
                <Modal.Body>
                    <div className='logout-modal-wrapper'>
                        {/* <div className='icon-wrap'><LogOutCircleIcon/></div> */}
                        <div className='logout-title'>Mark Complete</div>
                        <div className='logout-message'>Are you sure you want to mark complete?</div>
                        <div className='w-100 logout-btn-wrapper'><Button onClick={()=>handleSubmit()} variant='outline-primary'>Yes</Button> <Button onClick={()=>props.setOtpModal(false)} variant='outline-primary'>No</Button></div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default OTP